import React from 'react';
import { ThemeProvider } from 'styled-components';
import { makeTheme } from '@icecreamsocial/themes';
/**
 * @module SubscriptionsThemeProvider
 * @category Components
 * @subcategory Containers
 */

/**
 * @description
 * The storefront contains a very similar component.  The reason why this is not in the library
 * is because this is dependent on the structure of the store, which may differ from app to app.  If
 * we remove the store logic, it becomes the default theme provider from styled components and just
 * becomes an unnecessay abstraction
 * @todo
 * document this
 */

const SubscriptionsThemeProvider = ({ children, theme: themeOverrides }) => {
	const defaultTheme = makeTheme({
		colors: {
			accentLight: '#DDE1F9',
			bodyBg: 'transparent',
			ambient: '#EDEEEF',
			ambientDark: '#AAAAAA',
		},
	});
	const theme = makeTheme(themeOverrides, defaultTheme);

	return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

SubscriptionsThemeProvider.displayName = 'SubscriptionsThemeProvider';
export default SubscriptionsThemeProvider;
